import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnDestroy,
} from '@angular/core';
import '@sapudex/web-components/dist/Footer.js';
import {
  aboutSapLinksData,
  FooterSiteInformationClickDetail,
  quickLinksData,
  siteInformationLinksData,
  socialMediaData,
  trendingLinksData,
} from '@app/layout/footer/models/footer-data.model';
import {DcpCookiePreferencesService} from '@app/services/cookie-preferences/dcp-cookie-preferences.service';
import {JsonPipe} from '@angular/common';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dcp-udex-footer',
  templateUrl: './dcp-udex-footer.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [JsonPipe],
})
export class DcpUdexFooterComponent implements OnDestroy {
  protected readonly quickLinksData = quickLinksData;
  protected readonly trendingLinksData = trendingLinksData;
  protected readonly aboutSapLinksData = aboutSapLinksData;
  protected readonly siteInformationLinksData = siteInformationLinksData;
  protected readonly socialMediaData = socialMediaData;

  private readonly cookiePreferencesService = inject(DcpCookiePreferencesService);
  private footerEl: HTMLElement | null = null;

  private siteInformationClickHandler = (e: Event): void => {
    const event = e as CustomEvent<FooterSiteInformationClickDetail>;
    if (event.detail.id === 'cookie-preferences') {
      this.cookiePreferencesService.open();
    }
  };

  constructor() {
    afterNextRender(() => {
      this.footerEl = document.getElementById('udex-footer');
      this.footerEl?.addEventListener('site-information-click', this.siteInformationClickHandler);
    });
  }

  ngOnDestroy(): void {
    this.footerEl?.removeEventListener('site-information-click', this.siteInformationClickHandler);
  }
}
